import * as ActionTypes from './ActionTypes';
export function templatePreviewShowLoadingOverlay() {
  return {
    type: ActionTypes.TEMPLATE_PREVIEW_SHOW_LOADING_OVERLAY
  };
}
export function templatePreviewHideLoadingOverlay() {
  return {
    type: ActionTypes.TEMPLATE_PREVIEW_HIDE_LOADING_OVERLAY
  };
}
export function templatePreviewTriggerIFrameReload() {
  return {
    type: ActionTypes.TEMPLATE_PREVIEW_TRIGGER_IFRAME_RELOAD
  };
}
export function templatePreviewIFrameReloadToggled() {
  return {
    type: ActionTypes.TEMPLATE_PREVIEW_IFRAME_RELOAD_TRIGGERED
  };
}
export function updateTemplateEditorForm(updateData) {
  return {
    type: ActionTypes.TEMPLATE_EDITOR_UPDATE_FORM_SUCCESS,
    payload: updateData
  };
}
export function openTranslateTemplateModal() {
  return {
    type: ActionTypes.TEMPLATE_EDITOR_OPEN_TRANSLATE_TEMPLATE_MODAL
  };
}
export function closeTranslateTemplateModal() {
  return {
    type: ActionTypes.TEMPLATE_EDITOR_CLOSE_TRANSLATE_TEMPLATE_MODAL
  };
}